import * as angular from 'angular';
import * as _ from "lodash";
import {ConsolidatedBillingOrdersRequests} from "./consolidated-billing-orders-requests.service";
import {BillingAlertsService} from "./billing-alerts.service";
import {
  ExportConsolidatedBillingOrderTranslationsPayloadModel
} from "../models/export-consolidated-billing-order-translations-payload.model";
import {
  ExportConsolidatedBillingOrdersTablePayloadModel
} from "../models/export-consolidated-billing-orders-table-payload.model";
import {SapDocumentType} from "../types/sap-document.type";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";


export class ConsolidatedBillingOrderService {

  private base_url: any;

  /* @ngInject */
  constructor(private consolidatedBillingOrdersRequests: ConsolidatedBillingOrdersRequests,
              private $q: IQService, private $log, private bringozLoaderService: BringozLoaderService, private billingAlertsService: BillingAlertsService) {
  }

  getOne(consolidatedOrderId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.getOne(consolidatedOrderId)
      .then((response) => {
        deferred.resolve(response);
      })
      .catch((error) => {
        // this.billingAlertsService.createConsolidatedBillingOrderError();
        this.$log.error('Failed to get consolidated billing order', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  create(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.create(payload)
      .then((res) => {

        // response.billingOrdersNotFound
        const alreadyConsolidatedCount = _.get(res, 'notValidaBillingOrderMap.alreadyConsolidated.length', 0);
        const differentBillingAccountCount = _.get(res, 'notValidaBillingOrderMap.differentBillingAccount.length', 0);
        const notDeliveredStatusCount = _.get(res, 'notValidaBillingOrderMap.notDeliveredStatus.length', 0);

        if (!!alreadyConsolidatedCount || !!differentBillingAccountCount || !!notDeliveredStatusCount) {
          this.billingAlertsService.createConsolidatedBillingOrderPartialSuccess({
            alreadyConsolidated: alreadyConsolidatedCount,
            differentBillingAccount: differentBillingAccountCount,
            notDeliveredStatus: notDeliveredStatusCount
          });
        } else {
          this.billingAlertsService.createConsolidatedBillingOrderSuccess();
        }

        deferred.resolve(res);
      })
      .catch((error) => {
        this.billingAlertsService.createConsolidatedBillingOrderError();
        this.$log.error('Failed to create consolidated billing order', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  update(consolidatedId, name?, docDate?, comment?, billTo?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.update(consolidatedId, name, docDate, comment, billTo)
      .then((response) => {
        this.billingAlertsService.updateConsolidatedBillingOrderSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.updateConsolidatedBillingOrderError();
        this.$log.error('Failed to create consolidated billing order', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  bulkEditDate(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.bulkEditDate(payload)
      .then((response) => {
        this.billingAlertsService.updateConsolidatedBillingOrderSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.updateConsolidatedBillingOrderError();
        this.$log.error('Failed to create consolidated billing order', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  addBillingOrders(consolidatedId, payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.addBillingOrders(consolidatedId, payload)
      .then((response) => {
        this.billingAlertsService.updateConsolidatedBillingOrderSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.updateConsolidatedBillingOrderError();
        this.$log.error('Failed to create consolidated billing order', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  removeBillingOrders(consolidatedId, removeBillingOrderIds?, excludeBillingOrderIds?, removeAll?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.removeBillingOrders(consolidatedId, removeBillingOrderIds, excludeBillingOrderIds, removeAll)
      .then((response) => {
        this.billingAlertsService.updateConsolidatedBillingOrderSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.updateConsolidatedBillingOrderError();
        this.$log.error('Failed to create consolidated billing order', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }


  getPDF(consolidatedId, proformaPdfTemplate, includeEmptyPrices?: boolean, zoneId?) {
    const deferred = this.$q.defer<any>();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.getPDF(consolidatedId, proformaPdfTemplate, includeEmptyPrices, zoneId)
      .then((response) => {
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.printError();
        this.$log.error('Failed to get consolidated pdf', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  exportPDF(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.exportPDF(payload)
      .then((response) => {
        this.billingAlertsService.exportSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.exportError();
        this.$log.error('Failed to export consolidated pdf', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  exportCSV(consolidatedId, payload: ExportConsolidatedBillingOrderTranslationsPayloadModel, includeEmptyPrices?: boolean, zoneId?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.exportCSV(consolidatedId, payload, includeEmptyPrices, zoneId)
      .then((response) => {
        this.billingAlertsService.exportSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.exportError();
        this.$log.error('Failed to export consolidated CSV', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  exportTable(payload: ExportConsolidatedBillingOrdersTablePayloadModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.exportTable(payload)
      .then((response) => {
        this.billingAlertsService.exportSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.exportError();
        this.$log.error('Failed to export consolidated CSV', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  createInvoice(consolidatedId, sapDocumentType: SapDocumentType) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.createInvoice(consolidatedId, sapDocumentType)
      .then((response) => {
        this.billingAlertsService.invoiceCreationRequestSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.invoiceCreationRequestError(error);
        this.$log.error('Failed to export consolidated CSV', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  refund(consolidatedId: string, refundAmount: number, comment: string, dueDate: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.refund(consolidatedId, refundAmount, comment, dueDate)
      .then((response) => {
        this.billingAlertsService.invoiceCreationRequestSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.invoiceCreationRequestError(error);
        this.$log.error('Failed to export consolidated CSV', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  payManually(consolidatedId: string, payload?: { invoiceId: string }) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.payManually(consolidatedId, payload)
      .then((response) => {
        this.billingAlertsService.payManuallySuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.payManuallyError();
        this.$log.error('Failed to pay manually consolidated billing order', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  resetPayManually(payload?: { proformaId: string }) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedBillingOrdersRequests.resetPayManually(payload)
      .then((response) => {
        this.billingAlertsService.resetPayManuallySuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.resetPayManuallyError();
        this.$log.error('Failed to reset paid manually consolidated billing order', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .service('consolidatedBillingOrderService', ConsolidatedBillingOrderService);
